module.exports = __webpack_public_path__ + "img/入职.e1b666ec.svg";